import { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { toast } from 'sonner';
import { useLanguage } from '../context/LanguageContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success(t.newsletter.success);
      setEmail('');
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error('Email already subscribed');
      } else {
        toast.error(t.newsletter.error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="bg-[#0D0D0D] py-10 md:py-14" data-testid="newsletter-section">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto px-6 md:px-12"
      >
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          {/* Text */}
          <div className="text-center lg:text-left">
            <h3 className="font-bebas text-2xl md:text-3xl text-white tracking-wide">
              {t.newsletter.title}
            </h3>
            <p className="font-dm text-sm text-white/60 mt-1 max-w-md">
              {t.newsletter.subtitle}
            </p>
          </div>

          {/* Form */}
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto"
            data-testid="newsletter-form"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.newsletter.placeholder}
              required
              className="bg-white/10 border border-white/20 text-white placeholder:text-white/40 font-dm text-sm px-5 py-3 w-full sm:w-72 focus:outline-none focus:border-[#CE2B37] transition-colors duration-200"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              disabled={isLoading}
              className="bg-[#CE2B37] text-white font-bebas text-base tracking-wider px-6 py-3 hover:bg-[#a82230] transition-colors duration-200 disabled:opacity-50"
              data-testid="newsletter-submit-btn"
            >
              {isLoading ? '...' : t.newsletter.button}
            </button>
          </form>
        </div>
      </motion.div>
    </section>
  );
};
